
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diagnostics/failure",
      function () {
        return require("private-next-pages/diagnostics/failure/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diagnostics/failure"])
      });
    }
  